<mat-card appearance="outlined" class="dashboard-card single-card">
  <div class="dasboard-card-block">
    <a fxLayoutGap="40px">
      <span fxFlex="10" class="block-image">
        <img src="{{ needAssistance.image }}" alt="Need Assistance Image" />
      </span>
      <span fxFlex>
        <span class="block-heading">{{ needAssistance.name }}</span><br />
        <span class="block-description" [innerHTML]="needAssistance.description"></span>
      </span>
    </a>
  </div>
</mat-card>